'use strict';
console.log('Bundle-box script started');
(self.webpackChunkyourkaya = self.webpackChunkyourkaya || []).push([
  [4240],
  {
    3489: (e, t, n) => {
      var a = n(9897);

      const s = '.custom-settings__main-counter',
        r = '.custom-settings__qa-input',
        o = '.custom-settings__box',
        u = '.custom-settings__qa-button',
        i = '.product-form form',
        l = '.product-form__submit',
        c = '.product__variants-wrap',
        d = '.configurableOption',
        m = '.product-form__configurable';
      class h extends a.oi {
        constructor() {
          super();
          const onVariantChange = (event) => {
            if (event.detail?.container && !event.detail.container.contains(this)) return;
            this.updateInformationsOnPage();
          };
          document.addEventListener('onVariantChange', onVariantChange);
          document.addEventListener('quick-buy:variant-change', onVariantChange);
          setTimeout(() => {
            this.updateInformationsOnPage();
          }, 300);
        }

        connectedCallback() {
          super.connectedCallback();
          const root = this.closest('#fast-buy-drawer') || this.closest('main') || document;
          const e = this.querySelectorAll(u),
            t = this.querySelectorAll(r);

          e.forEach((e) => e.addEventListener('click', (e) => this.handleChangeQaByClick(e))),
            t.forEach((e) => {
              e.addEventListener('input', (e) => this.handleChangeQaByTyping(e)),
                e.addEventListener('focusout', (e) => this.handleLooseFocusOnInput(e));
            });
          const n = root.querySelectorAll(`${c} label`);
          const a = root.querySelector(m);
          const variantInputs = root.querySelectorAll(`${c} input[type="radio"]`);
          const refreshAfterSelection = () => {
            requestAnimationFrame(() => this.updateInformationsOnPage());
          };

          if (variantInputs.length) {
            variantInputs.forEach((input) => {
              input.addEventListener('change', refreshAfterSelection);
            });
          }

          if (n.length) {
            n.forEach((e) => {
              e.addEventListener('click', refreshAfterSelection);
            });
            this.updateInformationsOnPage();
          }

          if (a) {
            a.addEventListener('click', () => requestAnimationFrame(() => this.updateInformationsOnPage('customize')));
          }
        }

        updateInformationsOnPage(e) {
          const root = this.closest('#fast-buy-drawer') || this.closest('main') || document;
          const variantRadios = root.querySelector(c);
          const t = variantRadios?.querySelector(`${d}[type=radio]:checked`);
          const a = root.querySelector(i);
          const customConfigSizeLabel = variantRadios?.querySelector('label[data-parent="własna konfiguracja"][for]');
          const customConfigSizeInput = customConfigSizeLabel
            ? root.querySelector(`#${customConfigSizeLabel.getAttribute('for')}`)
            : null;

          if (!variantRadios || !a) return;

          const o = a.querySelector(l);
          if (!o) return;

          const variantRadiosChildren = variantRadios.children;
          const numChildren = variantRadios.children.length;
          const fieldSet = variantRadiosChildren[numChildren - 2];
          const fieldSetSize = variantRadiosChildren[1];

          if (t) {
            if (customConfigSizeInput && !customConfigSizeInput.checked) {
              customConfigSizeInput.checked = true;
              customConfigSizeInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            fieldSet.style.display = 'none';
            fieldSetSize.style.display = 'none';

            o.querySelector('span').innerText = 'Dodaj do koszyka';
          } else {
            if (
              (window.productData && window.productData.handle === 'tampony') ||
              window.location.href.includes('tampony')
            ) {
              fieldSetSize.style.display = 'flex';
              fieldSet.style.display = 'flex';

              if (customConfigSizeLabel) {
                customConfigSizeLabel.style.display = 'none';
              }
            }
          }

          let isFull = false;
          const allSubmitButtons = document.querySelectorAll(l);

          const btnDisableHandler = (btn) => {
            btn.disabled = true;
            btn.parentElement.setAttribute(
              'data-tooltip-content',
              'Dodaj 24 szt. tamponów do konfigurowanego opakowania.'
            );

            const subTrigger = document.getElementById('widget-add-to-sub-trigger');
            if (subTrigger) {
              subTrigger.disabled = true;
            }
          };

          const btnEnableHandler = (btn) => {
            btn.disabled = false;
            btn.parentElement.removeAttribute('data-tooltip-content');

            const subTrigger = document.getElementById('widget-add-to-sub-trigger');
            if (subTrigger) {
              subTrigger.disabled = false;
            }
          };

          t ? this.classList.remove('hidden') : this.classList.add('hidden');
          const r = this.reservedQuantity();

          if (((this.querySelector(`${s} span`).textContent = r), !a)) return;

          if (r === Number(this.getAttribute('maximum'))) {
            allSubmitButtons.forEach((btn) => btnEnableHandler(btn));
            isFull = true;
          } else {
            if (!this.classList.contains('hidden')) {
              allSubmitButtons.forEach((btn) => btnDisableHandler(btn));
              isFull = false;
            }
            if (e === 'plus' && r !== Number(this.getAttribute('maximum'))) {
              allSubmitButtons.forEach((btn) => btnDisableHandler(btn));
            }
          }

          this.querySelectorAll('input').forEach((e) => {
            const s = a.querySelector(`input[name="${e.name}"]`);

            if (t) {
              if (Number(e.value) === 0) {
                e.parentElement.parentElement.classList.add('empty');
                e.previousElementSibling.setAttribute('disabled', 'true');
              } else {
                e.parentElement.parentElement.classList.remove('empty');
                e.previousElementSibling.removeAttribute('disabled');
              }

              if (isFull) {
                e.parentElement.classList.add('full');
                e.nextElementSibling.setAttribute('disabled', 'true');
              } else {
                e.parentElement.classList.remove('full');
                e.nextElementSibling.removeAttribute('disabled');
              }

              if (s) {
                s.value = e.value;
              } else {
                a.appendChild(e.cloneNode(true));
              }
            } else {
              if (s) {
                s.remove();
              }
            }
          });
        }
        reservedQuantity() {
          let e = 0;
          return (
            this.querySelectorAll(r).forEach((t) => {
              e += Number(t.value);
            }),
            Number(e)
          );
        }
        handleChangeQaByClick(e) {
          let target = e.target;
          if (('BUTTON' !== target.nodeName && (target = target.closest('button')), !target || !target.name)) return;
          const n = target.closest(o).querySelector(r);
          if ('plus' === target.name) {
            const { max: e } = n;
            this.reservedQuantity() < Number(e) && n.stepUp();
          } else n.stepDown();
          this.updateInformationsOnPage('plus');
        }
        handleChangeQaByTyping(e) {
          const t = e.target;
          (t.value = t.value.replace(/^0+/, '')),
            Number(t.max) - this.reservedQuantity() < 0 &&
              (t.value -= Math.abs(Number(t.max) - this.reservedQuantity())),
            Number(t.value) < Number(t.min) && (t.value = t.min),
            this.updateInformationsOnPage();
        }
        handleLooseFocusOnInput(e) {
          e.target.value || (e.target.value = e.target.min);
        }
        render() {
          return a.dy`
      <div>
        <slot name="content"></slot>
      </div>
    `;
        }
      }
      customElements.define('bundle-box', h);
    },
  },
  (e) => {
    e.O(0, [1216], () => {
      return (t = 3489), e((e.s = t));
      var t;
    });
    e.O();
  },
]);
